export const LEFT_ARROW = 37;
export const LEFT_LETTER = 65;
export const UP_ARROW = 38;
export const UP_LETTER = 87;
export const RIGHT_ARROW = 39;
export const RIGHT_LETTER = 68;
